import { cancerscreenValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/cancerscreen.validation-set';
import { carrierValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/carrier.validation-set';
import { galleriValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/galleri.validation-set';
import { monoValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/mono.validation-set';
import { negSingleCarrierValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/neg-single-carrier.validation-set';
import { niptValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/nipt.validation-set';
import { nipptValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/nippt.validation-set';
import { paternityValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/paternity.validation-set';
import { rhValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/rh.validation-set';
import { venisafeMaternaValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/venisafe-materna.validation-set';
import { venisafeValidationSet } from '@app/modules/service-data/components/service-data/service-data-form/validation-sets/venisafe.validation-set';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { DataInputType } from '@core/core.types';
import { otherValidationSet } from './validation-sets/other.validation-set';

export const serviceDataValidationGroups: {
  [groupKey: string]: ValidationPair;
} = {
  [DataInputType.NIPT]: niptValidationSet,
  [DataInputType.NIPPT]: nipptValidationSet,
  [DataInputType.MONO]: monoValidationSet,
  [DataInputType.RH]: rhValidationSet,
  [DataInputType.CARRIER]: carrierValidationSet,
  [DataInputType.CANCERSCREEN]: cancerscreenValidationSet,
  [DataInputType.GALLERI]: galleriValidationSet,
  [DataInputType.PATERNITY]: paternityValidationSet,
  [DataInputType.NEGSINGLECARRIER]: negSingleCarrierValidationSet,
  [DataInputType.VENISAFE]: venisafeValidationSet,
  [DataInputType.VENISAFEMATERNA]: venisafeMaternaValidationSet,
  [DataInputType.OTHER]: otherValidationSet,
};
